import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"search\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 6a9 9 0 0 1 7.032 14.617l3.675 3.676a1 1 0 0 1-1.32 1.497l-.094-.083-3.676-3.675A9 9 0 1 1 15 6Zm0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z\" fill=\"#3B3F3D\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol